module.exports = __webpack_public_path__ + "static/btn-no-d7d709e128772401f5dfdab77f380bab.png";